import ky from 'ky/umd';
import { Input, Options } from 'ky';
import { defaultHeaders, defaultKyOptions, FetcherOptions, KyOptions } from '.';
import { info } from '../utils/logger';

// used internally to test retries
const failMap = {};

/**
 * Ky fetcher instantiator
 *
 * @param opts options for the fetcher instantiator
 */
export default function fetcher<T>(opts: FetcherOptions = {}) {
  // DocGen (used in storybook) will add a `displayName` and `__docgenInfo` property to the defaultHeaders object...
  // need to remove these to make sure CORS requests will work as expected because CORS will complain if a specific header
  // is not defined in the Access-Control-Allow-Headers response header
  delete defaultHeaders['displayName'];
  delete defaultHeaders['__docgenInfo'];

  return async function (input: Input): Promise<T> {
    const options: KyOptions = {
      ...defaultKyOptions,
      json: opts.json,
      body: opts.body,
      method: opts.method,
      hooks: {
        ...defaultKyOptions.hooks,
        ...opts.hooks,
      },
      throwHttpErrors: opts.throwHttpErrors,
      onDownloadProgress: opts.onDownloadProgress,
      headers: { ...defaultHeaders, ...opts.headers },
    };
    try {
      const url = input.toString();

      // test failure retries by throwing an error for the first 2 tries
      if (opts.testRetry) {
        if (!failMap[url]) {
          failMap[url] = {
            failCount: 0,
          };
        }
        const failMapping = failMap[url];
        if (failMapping) {
          if (failMapping.failCount < 3) {
            failMapping.failCount = failMapping.failCount + 1;
            console.log('failMapping', failMapping);
            throw new Error('test failure');
          }
        }
      }

      info('KY: fetching', input, options);
      const result = await ky(input.toString(), options as Options).json<T>();
      info('KY: successful fetch', input, options);

      return result;
    } catch (error) {
      // console.error('KY failed to fetch', input, options, error);
      if (error.name === 'TimeoutError') {
        return null;
      }
      throw error;
    }
  };
}
